import { app } from '../../../../../app';
import { Controller } from './edit-policy.controller';

app.component('passwordAuthenticationPoliciesViewEdit', {
    bindings:{
        companyPasswordPolicies:'<',
        policy:'<'
    },
    controller: Controller,
    templateUrl: require('./edit-policy.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/edit-policy/edit-policy.component.js